export const KSUITE = 'ksuite' as const;
export const EURIA = 'euria' as const;
export const CALENDAR = 'calendar' as const;
export const CHK = 'chk' as const;
export const CONTACTS = 'contacts' as const;
export const KCHAT = 'kchat' as const;
export const KDRIVE = 'kdrive' as const;
export const SMS = 'sms' as const;
export const KMEET = 'kmeet' as const;
export const KPASTE = 'kpaste' as const;
export const MAIL = 'mail' as const;
export const SWISSTRANSFER = 'swisstransfer' as const;

export const ProductNames = {
  KSUITE,
  EURIA,
  CALENDAR,
  CHK,
  CONTACTS,
  KCHAT,
  KDRIVE,
  SMS,
  KMEET,
  KPASTE,
  MAIL,
  SWISSTRANSFER,
} as const;
export type ProductNames = typeof ProductNames;
export type ProductName = (typeof ProductNames)[keyof typeof ProductNames];
